module.exports = __webpack_public_path__ + "static/media/perkbox_logo.35d4898d.png";